import { IP } from 'entities/ip';
import { Selectors as Router } from 'router';
import { simpleClient } from 'services/apiGatewayClient';
import { State } from 'store';
import { createService, RestApiId } from '../genericAPIGatewayService';

const client = simpleClient<IP>();
const endpointCreator = (state: State) => {
  const siteId = Router.getSiteId(state);
  return siteId ? `/sites/${siteId}/blacklisted_ips` : undefined;
};

export const { Actions, Selectors, Sagas } = createService<IP>({
  service: RestApiId.IP_BLACKLIST,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.data.ipBlacklist,
  sagas: ['CREATE', 'DELETE', 'GET_COLLECTION', 'REDIRECT_AFTER_CREATE'],
  redirectAfterCreateUrl: (siteId: string, _: string) => `/sites/${siteId}/blacklisted_ips`,
});
